export default __webpack_public_path__ + "static/media/grpc2.3c9d4588.svg";